import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Button } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';
import logo from 'assets/images/logo.png';
import imageMessage from 'assets/images/new-message.png';

const CheckEmail = () => {
    const { t } = useTranslation();

    return (
        <div className="form-signin mt-121">
            <img className="logo" src={logo} alt="" />
            <h3>{t('check_email')}</h3>
            <p>{t('text_check_email')}</p>
            <img className="message-img" src={imageMessage} alt="" />
            <Button className="authentication-btn" type="primary" htmlType="submit">
                {t('open_email')}
            </Button>
            <Link to={'/'} className="skip-confirm mt-40">
                {t('skip_confirm')}
            </Link>
            <Link to={'/forgot-password'} className="btn-back mt-16">
                <ArrowLeftOutlined /> {t('back')}
            </Link>
        </div>
    );
};

export default CheckEmail;
